import React from 'react';
import QueryClassificationHome from '../components/queryclassificationHome';
import Navigation from '../components/Navigation';

const QueryClassificationPage = () => {
  return (
    <div className="min-h-screen bg-pl_bg_light_5">
      <Navigation />
      <QueryClassificationHome />
    </div>
  );
};

export default QueryClassificationPage; 